import { render } from "./AppTicket.vue?vue&type=template&id=672ef3c0&scoped=true&lang=pug"
import script from "./AppTicket.vue?vue&type=script&lang=js"
export * from "./AppTicket.vue?vue&type=script&lang=js"

import "./AppTicket.vue?vue&type=style&index=0&id=672ef3c0&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672ef3c0"]])

export default __exports__